import LoadingButton from "@mui/lab/LoadingButton";
import { Button } from "@mui/material";

const ToolBarItems = ({
  submitText = "Submit",
  submitColor = "primary",
  cancelText = "Cancel",
  showCancel = true,
  showSubmit = true,
  onCancel = () => {},
  onSubmit = () => {},
  // Per call site testids (no generic default: two toolbars on one page would
  // collide under Playwright's strict mode). Only pass these where a spec
  // actually selects the buttons.
  submitTestId = undefined,
  cancelTestId = undefined,
  // Async submit handlers pass their in-flight state here; the button has no
  // way to observe a promise returned from onSubmit.
  loading = false,
  style = {},
}) => {
  return (
    <>
      <div
        style={{
          marginTop: "auto",
          display: "flex",
          justifyContent: "flex-end",
          ...style,
        }}
      >
        {!loading && showCancel && (
          <Button
            style={{ marginRight: "10px" }}
            size="small"
            disabled={loading}
            onClick={onCancel}
            data-testid={cancelTestId}
          >
            {cancelText}
          </Button>
        )}
        {showSubmit && (
          <LoadingButton
            loading={loading}
            variant="contained"
            color={submitColor}
            size="small"
            onClick={onSubmit}
            data-testid={submitTestId}
          >
            {submitText}
          </LoadingButton>
        )}
      </div>
    </>
  );
};

export default ToolBarItems;
